import axios from 'axios'
import helpers from "@/services/helpers";
import './i18n'
let country = localStorage.getItem("Content-Country");
let city = localStorage.getItem("Content-City");
if (country !== null && city !== null) {
  //  
} else {
  // COUNTRY
  const countryDefault = { label: "Switzerland", value: 214, iso: 'ch' };
  localStorage.setItem("Content-Country", JSON.stringify(countryDefault));
  // CITY
  const cityDefault = { label: "Aadorf", value: 17356 };
  localStorage.setItem("Content-City", JSON.stringify(cityDefault));
}

const api = axios
api.defaults.baseURL = process.env.VUE_APP_API_URL

axios.interceptors.request.use(function (config) {
  config.headers['Content-Language'] = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
  config.headers['Content-Country'] = JSON.parse(country).value
  config.headers['Content-City'] = JSON.parse(city).value
  return config;
});

axios.interceptors.response.use((response) => {
  if (response.config.parse) {
    // console.log(response)
  }
  return response;
}, (error) => {
  // console.log(error.response)
  helpers.handleError(error);
  return;
});
api.defaults.withCredentials = true
export default api
